import axios from 'axios';
import K from '../constants/VideosConstants';

export function getVideos(category) {
    return dispatch => {
        const endpoint = `${
            process.env.REACT_APP_API_URL
        }/api/videos?filter={"where": {"category":"${category}"},"order":"createdOn DESC"}`;

        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_VIDEOS,
                    payload: response.data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/VideosActions.js